import type { ReactNode } from 'react';
import { NuvoGrid } from '@nuvolo/nuux-core/components/NuvoGrid';
import { NuvoText } from '@nuvolo/nuux-core/components/NuvoText';
import { Divider } from '@mui/material';
import { FieldItemProps, SimpleFieldItemProps } from './RecordPreviewProps';

const renderGroup = <T,>(
  { items: childItems }: FieldItemProps<T>,
  i: number,
  totalItems: number,
) => (
  <>
    {renderItems(childItems || [])}
    {i < totalItems - 1 && <Divider />}
  </>
);

const renderSimpleItem = (item: SimpleFieldItemProps, i: number) => {
  return (
    item.visible && (
      <NuvoGrid item key={`${item.dataField}${i}`} {...item.gridOptions}>
        {item.render ? (
          item.render()
        ) : (
          <NuvoText type="large" className={`${item.cssClass} record-preview-text`}>
            {item.value}
          </NuvoText>
        )}
        <NuvoText type="body" className="record-preview-label">
          {item.label}
        </NuvoText>
      </NuvoGrid>
    )
  );
};

const renderItem = <T,>(
  item: FieldItemProps<T>,
  i: number,
  items: FieldItemProps<T>[],
): ReactNode => {
  if (item.itemType === 'group') {
    return renderGroup(item, i, items.length);
  }
  if (item.itemType === 'simple') {
    return renderSimpleItem(item, i);
  }
  return null;
};

const renderItems = <T,>(items: FieldItemProps<T>[]) => {
  return items.map(renderItem);
};

export default renderItems;
